// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1Kze0","header":"MergedInvoice_header__2sQAZ"};